export const DEFAULT_AVATAR_URL = 'https://staticcontent.knowledgehook.com/content/khg/misc/default_user_zogear_dog.png';
